namespace $.$$ {
	/** Compatibility host for saved community-list editors, not a second implementation. */
	export class $shm_hitalama_vk_group_search extends $.$shm_hitalama_vk_group_search {
		fqn() { return '$' + 'shm2_vk_group_search' }
		@ $mol_mem
		instance() {
			const view = super.instance() as any
			view.token_str = ()=> this.token_str()
			view.buttons = ()=> this.buttons()
			return view
		}
		dto(): $shm_hitalama_vk_group_dto | null {
			const dto = this.instance().dto()
			return dto ? { ...dto, id: String( dto.id ) } : null
		}
	}
}
